/** Server xatosi (HTTP status va tanasi bilan). */
export class ApiError extends Error {
  constructor(
    public status: number,
    public body: unknown,
  ) {
    super(`HTTP ${status}`);
  }
}

interface Result<T> {
  data?: T;
  error?: unknown;
  response: Response;
}

/** openapi-fetch natijasini ochadi: muvaffaqiyat bo'lmasa ApiError tashlaydi (React Query uchun). */
export function unwrap<T>(res: Result<T>): T {
  if (!res.response.ok) throw new ApiError(res.response.status, res.error);
  return res.data as T;
}

/** DRF xato tanasidan odam o'qiydigan matn. */
export function errorMessage(err: unknown, fallback: string): string {
  if (!(err instanceof ApiError)) return fallback;
  const b = err.body;
  if (typeof b === "string" && b.length < 200) return b;
  if (b && typeof b === "object") {
    const obj = b as Record<string, unknown>;
    if (typeof obj.detail === "string") return obj.detail;
    const parts: string[] = [];
    for (const [k, v] of Object.entries(obj)) {
      const msg = Array.isArray(v) ? v.join(", ") : typeof v === "string" ? v : null;
      if (msg) parts.push(k === "non_field_errors" ? msg : `${k}: ${msg}`);
    }
    if (parts.length) return parts.join("; ");
  }
  return fallback;
}

export const isConflict = (err: unknown) => err instanceof ApiError && err.status === 409;
